import { Country } from '@tiendanube/common/src/enums';
import { partnersAppsRoutes } from '../PartnersApps';

export const NUVEM_ENVIO_ROUTES = {
  [Country.BR]: `${partnersAppsRoutes.nuvemenvioBilling}`,
  [Country.AR]: `${partnersAppsRoutes.envionubeBillingAr}`,
  [Country.MX]: `${partnersAppsRoutes.envionubeBillingMx}`,
};
